import { COLOR_PALETTE } from 'constants/ui';

export const getHeadLabelStyles = ({ isPending }) => ({
  backgroundColor: isPending ? COLOR_PALETTE.ADDITIONAL[1] : COLOR_PALETTE.BLUE[2],
  color: isPending ? COLOR_PALETTE.ADDITIONAL[2] : COLOR_PALETTE.BLUE[10],
  display: 'inline-block',
  padding: '2px 8px',
  fontSize: '12px',
  borderRadius: '5px',
  fontWeight: 700,
  marginRight: '10px',
});
